<div style="width: 719px">
  <img class="qr" [src]="'assets/images/qr.png'" [srcset]="'assets/images/qr@2x.png 2x, assets/images/qr@3x.png 3x'" alt="logo">
  <label class="description">Paycell mobil uygulamasıyla QR kodu okutarak <span class="text-style"> ödemenizi mobil üzerinden tamamlayabilirsiniz</span></label>
</div>
